import React from 'react';
import classnames from 'classnames';

import type { GroupRow } from './types';
import { GroupRowType } from './types';

import Tooltip, { Placement } from 'js/src/components/common/ui/Tooltip';

type AIVoiceGroupRowProps = {
    className?: string;
    data: GroupRow;
    style: React.CSSProperties;
    containerRef: React.RefObject<HTMLDivElement | null>;
};

const AIVoiceGroupRow: React.FC<AIVoiceGroupRowProps> = ({
    className,
    data,
    style,
    containerRef,
}) => {
    const isLegacy = data.id === GroupRowType.Legacy;

    return (
        <div className={classnames('row', className)} style={style}>
            <div className="col font-l5 font-l5--subtitle-l color-grey-600">
                {data.title}
                {isLegacy && (
                    <Tooltip
                        html={true}
                        title="Legacy voices may be less consistent in tone and may experience more audio anomalies."
                        placement={Placement.RIGHT}
                        container={containerRef.current}
                        trigger="hover"
                    >
                        <i className="material-symbols-outlined icon-l5 icon-l5--small color-grey-600 ms-l5-4 cursor-pointer">
                            info
                        </i>
                    </Tooltip>
                )}
            </div>
        </div>
    );
};

export default AIVoiceGroupRow;
